import "./style.css";

const AdminInput = ({
  type = "text",
  prefixIcon = null,
  suffixIcon = null,
  placeholder = "",
  mb = "mb-3",
  onChange,
  onClick,
  value,
  name = "",
  label = null,
  disable = false,
  onBlur,
  isInvalid = false,
  invalidMessage = "",
  readOnly = false,
  inputClassName = "",
}) => {
  return (
    <>
      <div className={mb}>
        {label && <label className="tw:!mb-1 tw:!text-[15px] tw:!text-[#8D8D8D]">{label}</label>}
        <div className="w-100 rounded border">
          <div className="tw:flex! tw:justify-center! tw:items-center! d-flex gap-2 input-container">
            {prefixIcon && (
              <span className="ms-3">
                {prefixIcon}
              </span>
            )}
            <input
              className={`
                tw:!border-none 
                tw:!outline-none 
                tw:!w-full 
                tw:!leading-[32px] 
                tw:rounded 
                tw:border-0 
                tw:py-2 
                tw:!text-[15px] 
                tw:!font-['Hanken_Grotesk'] 
                tw:placeholder:!text-[15px] 
                tw:placeholder:!font-['Hanken_Grotesk'] 
                no-calendar 
                ${readOnly ? 'tw:!bg-[#F9F9F9]' : ''} 
                ${prefixIcon != null ? '' : 'px-3'} 
                ${disable ? 'tw:!bg-[#F9F9F9]' : ''} 
                ${isInvalid ? 'invalid' : ''} 
                ${inputClassName}
              `}
              type={type}
              placeholder={placeholder}
              onChange={(e) => onChange(e)}
              onClick={onClick}
              name={name}
              value={value}
              disabled={disable}
              onBlur={onBlur}
              onWheel={(e) => e.target.blur()}
              readOnly={readOnly}
            />
            {suffixIcon && (
              <span className="me-3">
                {suffixIcon}
              </span>
            )}
          </div>
        </div>
        {
          (isInvalid && invalidMessage !== "") &&
          (
            <p className="text-danger">
              {invalidMessage}
            </p>
          )
        }
      </div>
    </>
  );
};

export default AdminInput;
